<template>
  <div class="leaderboard">
    <SiestaHeader />
    <p class="header">LEADERBOARD</p>
    <div class="vertical-spacer top-spacer"></div>
    <div v-if="users.length > 0" class="users">
      <template v-for="(record, i) in users">
        <li :key="i + 'li'" :class="{ userSubmission: record.submission }">
          <span>{{ record.initials }}</span>
          <span>.....</span>
          <span>{{ record.score.toLocaleString() }}</span>
        </li>
      </template>
    </div>
    <SiestaClose />
  </div>
</template>

<script>
import SiestaHeader from "@/components/SiestaHeader";
import SiestaClose from "@/components/results/SiestaClose";
import { request } from "@/store/request";
const url = "/api/leaderboard";

export default {
  name: "leaderboard",
  data() {
    return {
      users: []
    };
  },
  components: {
    SiestaHeader,
    SiestaClose
  },
  computed: {
    game() {
      return this.$store.state.game;
    }
  },
  mounted() {
    request(`${url}/list`, "GET").then(res => {
      if (res.success) {
        res.users.forEach(user => {
          if (
            user.timestamp >= this.game.started &&
            user.initials == this.game.initials &&
            user.score == this.game.points
          ) {
            user.submission = true;
          }
        });
        this.users = res.users;
      }
    });
  }
};
</script>

<style lang="scss" scoped>
$user-submission-color: blue;

.leaderboard {
  padding: rems(24px) rems(24px) rems(32px) rems(24px);
  position: relative;
  text-align: center;
}
.header {
  font-size: rems(64px);
  letter-spacing: rems(6px);
}

.users {
  width: 100%;
  margin: 0 auto;
  text-align: center;

  li, ul {
    list-style: none;
    margin: 0;
    padding: 0;
    font-size: rems(64px);
  }
}

.userSubmission {
  animation: 0.3s blink infinite;
  animation-direction: alternate-reverse;
}
@keyframes blink {
  from {
    color: rgba(#fff, 1);
  }
  to {
    // opacity: 1;
    color: rgba(#fff, 0.3);
  }
}
</style>
